export default __webpack_public_path__ + "static/media/asiacup-matthew.adaef581.png";